import { useState } from 'react';
import styles from './TilingLoader.module.css';

interface TilingLoaderProps {
  onLoadTiling: (tilingString: string) => void;
  onExportTiling: () => string;
}

export function TilingLoader({ onLoadTiling, onExportTiling }: TilingLoaderProps) {
  const [tilingInput, setTilingInput] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<'success' | 'error' | 'info'>('info');

  const handleLoadTiling = () => {
    if (!tilingInput.trim()) {
      setMessage('Please enter a tiling string');
      setMessageType('error');
      return;
    }

    try {
      onLoadTiling(tilingInput.trim());
      setMessage('Tiling loaded successfully!');
      setMessageType('success');
      setTilingInput('');
    } catch (error) {
      setMessage(`Error: ${error instanceof Error ? error.message : 'Failed to load tiling'}`);
      setMessageType('error');
    }
  };

  const handleExportTiling = () => {
    try {
      const tiling = onExportTiling();
      setTilingInput(tiling);
      setMessage('Tiling exported to input');
      setMessageType('success');
    } catch (error) {
      setMessage(`Error: ${error instanceof Error ? error.message : 'Failed to export tiling'}`);
      setMessageType('error');
    }
  };

  return (
    <div className={styles.tilingLoader}>
      <div className={styles.section}>
        <h3>Tiling Loader</h3>
        <p className={styles.hint}>
          Format: <code>Piece(x,y,rotation,mirrored)[,Piece(...)]</code>
        </p>
        <p className={styles.example}>
          Example: <code>O(0,0,0,0),I(2,0,1,1),L(4,1,2,0)</code>
        </p>

        <textarea
          className={styles.input}
          value={tilingInput}
          onChange={(e) => setTilingInput(e.target.value)}
          placeholder="Paste a tiling string here..."
          rows={3}
        />

        <div className={styles.buttons}>
          <button onClick={handleLoadTiling} className={styles.buttonPrimary}>
            Load Tiling
          </button>
          <button onClick={handleExportTiling} className={styles.buttonSecondary}>
            Export Current
          </button>
        </div>

        {message && (
          <div className={`${styles.message} ${styles[messageType]}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
}
